import type { Currency } from "@/lib/domain/Currency";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export interface GetPreferredCurrencyResponseModel {
	readonly currency: Currency;
}

export const usePreferredCurrency = () => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["preferredCurrency"],
		queryFn: () => {
			return http<GetPreferredCurrencyResponseModel>({
				method: "GET",
				url: "/settings/preferred-currency"
			});
		}
	});
};
